import React from "react";
import { MapPin, Instagram, MessageCircle, Phone } from "lucide-react";
import { SITE, waLink } from "../../lib/site";
import Reveal from "../Reveal";

export default function Location() {
  return (
    <section
      id="contato"
      data-testid="location-section"
      className="relative overflow-hidden py-24 sm:py-32 text-white bg-transparent"
    >
      <div className="absolute inset-0 paw-tile opacity-10 pointer-events-none" />

      <div className="container-pad relative z-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5 space-y-5">
          <Reveal as="div" className="inline-block px-4 py-1.5 rounded-full bg-white/10 backdrop-blur-xl border border-white/15 text-white text-xs font-bold uppercase tracking-[0.18em]">
            Onde estamos
          </Reveal>

          <Reveal as="h2" delay={80} className="font-heading text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.1]">
            Venha nos <span className="italic text-gold">visitar</span>.
          </Reveal>

          <Reveal as="p" delay={140} className="text-white/75 leading-relaxed">
            Estamos prontos para receber você e seu pet em um ambiente acolhedor, seguro e cheio de carinho.
          </Reveal>

          <div className="space-y-3 mt-6">
            <Reveal delay={180} className="flex items-start gap-4 p-4 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/15 shadow-[0_25px_80px_rgba(0,0,0,.20)] hover:bg-white/15 hover:-translate-y-1 transition-all">
              <div className="w-11 h-11 rounded-xl bg-gold text-royal flex items-center justify-center shrink-0">
                <MapPin className="w-5 h-5" />
              </div>

              <div>
                <div className="text-xs uppercase tracking-wider text-white/55 font-semibold">Endereço</div>
                <div className="text-white font-medium" data-testid="location-address">{SITE.address}</div>
              </div>
            </Reveal>

            <div className="grid grid-cols-3 gap-3 mt-4">
              <a
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                data-testid="location-whatsapp"
                className="group flex flex-col items-center gap-2 p-4 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/15 hover:bg-white/16 hover:-translate-y-1 transition-all"
              >
                <MessageCircle className="w-5 h-5 text-gold" />
                <span className="text-xs font-semibold text-white">WhatsApp</span>
              </a>

              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noreferrer"
                data-testid="location-instagram"
                className="group flex flex-col items-center gap-2 p-4 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/15 hover:bg-white/16 hover:-translate-y-1 transition-all"
              >
                <Instagram className="w-5 h-5 text-gold" />
                <span className="text-xs font-semibold text-white">{SITE.instagram}</span>
              </a>
            </div>
          </div>
        </div>

        <Reveal as="div" delay={120} className="lg:col-span-7">
          <div className="rounded-[36px] overflow-hidden border border-white/15 bg-white/10 backdrop-blur-2xl shadow-[0_35px_100px_rgba(0,0,0,.30)] hover:shadow-[0_45px_120px_rgba(0,0,0,.40)] transition-all duration-700">
            <iframe
              title="Localização Tia Sandra Pet Care"
              src={SITE.mapsEmbed}
              width="100%"
              height="520"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
